export default __webpack_public_path__ + "static/media/internetb.074dcfff.svg";